<mat-card class="table-summary-widget">
  <mat-card-header>
    <mat-card-title>{{ title }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    @if (isLoading) {
      <div class="state-message" aria-live="polite">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Loading table summary…</span>
      </div>
    } @else if (summary) {
      <div class="summary-grid">
        <div class="summary-item">
          <mat-icon>list</mat-icon>
          <div>
            <span class="label">Approximate records</span>
            <span class="value">{{ summary.totalItems | number }}</span>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon>storage</mat-icon>
          <div>
            <span class="label">Table size</span>
            <span class="value">{{ formatBytes(summary.tableSizeBytes) }}</span>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon [class]="getStatusClass(summary.tableStatus)">{{
            getStatusIcon(summary.tableStatus)
          }}</mat-icon>
          <div>
            <span class="label">Table status</span>
            <span class="value" [class]="getStatusClass(summary.tableStatus)">
              {{ summary.tableStatus || 'Unavailable' }}
            </span>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon>event</mat-icon>
          <div>
            <span class="label">Table created</span>
            <span class="value">{{
              summary.createdAt ? formatDate(summary.createdAt) : 'Unavailable'
            }}</span>
          </div>
        </div>
      </div>
    } @else {
      <div class="state-message" [class.error]="error" role="status">
        <mat-icon>{{ error ? 'error_outline' : 'info' }}</mat-icon>
        <span>{{
          error
            ? 'Table summary is currently unavailable.'
            : 'No table information available.'
        }}</span>
      </div>
    }
  </mat-card-content>
</mat-card>
